/* istanbul ignore file */
// Ignoring coverage for this file since it is just a re-export
// eslint-disable-next-line lumapps/do-not-import-axios
import axios from 'axios';

export const { isCancel } = axios;
